/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown>, product: NonNullable<unknown> }} Release_Inventory_Hold_DescriptionInputs */

const en_release_inventory_hold_description = /** @type {(inputs: Release_Inventory_Hold_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Release ${i?.quantity} bags of ${i?.product}?`)
};

const es_release_inventory_hold_description = /** @type {(inputs: Release_Inventory_Hold_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Liberar ${i?.quantity} bolsas de ${i?.product}?`)
};

/**
* | output |
* | --- |
* | "Release {quantity} bags of {product}?" |
*
* @param {Release_Inventory_Hold_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const release_inventory_hold_description = /** @type {((inputs: Release_Inventory_Hold_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Inventory_Hold_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_release_inventory_hold_description(inputs)
	return es_release_inventory_hold_description(inputs)
});